<template>
  <div class="uploadImg-item">
    <div
      style="display: flex; flex-wrap: wrap; justify-content: center; width: 100%;"
    >
      <div
        class="ant-upload-picture-card-wrapper img-card"
        v-for="(url, index) in imageUrlList"
        :key="index"
      >
        <div class="img-wrapper">
          <img class="img" :src="url" alt="avatar" />
          <div class="hover-img">
            <EyeOutlined style="color: #FFF;" @click.stop="openView(url)" />
            &nbsp;&nbsp;
            <DeleteOutlined style="color: #FFF;" @click.stop="delImg(index)" />
          </div>
        </div>
      </div>

      <a-upload
        v-if="imageUrlList.length < limit"
        accept="image/*"
        list-type="picture-card"
        class="avatar-uploader"
        :show-upload-list="false"
        :maxCount="1"
        :customRequest="beforeUpload"
      >
        <div>
          <loading-outlined v-if="loading"></loading-outlined>
          <plus-outlined v-else></plus-outlined>
          <div class="ant-upload-text">上传图片</div>
        </div>
      </a-upload>
    </div>
    <div class="tip">
      {{ tip }}
    </div>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewUrl" />
    </a-modal>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import {
  PlusOutlined,
  LoadingOutlined,
  EyeOutlined,
  DeleteOutlined
} from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { formRequest } from 'cupshe-axios'
export default {
  components: {
    PlusOutlined,
    LoadingOutlined,
    DeleteOutlined,
    EyeOutlined
  },
  props: {
    imageType: Object,
    fileList: [String, Array],
    type: String,
    valueType: {
      type: String,
      default: 'string'
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  setup(props, { emit }) {
    const tip = ref(props.imageType.tip)
    const loading = ref(false)
    const previewVisible = ref(false)
    const previewUrl = ref('')

    const imageUrlList = computed(() => {
      const url = props.fileList
      if (!url) return []
      if (props.valueType === 'arrayObject') {
        return Array.isArray(url) ? url.map(item => item.url || item) : []
      } else {
        return typeof url === 'string' ? url.split(',').filter(Boolean) : []
      }
    })

    const emitChange = list => {
      let res
      if (props.valueType === 'arrayObject') {
        const originalArray = Array.isArray(props.fileList)
          ? props.fileList
          : []
        res = list.map(url => {
          const existing = originalArray.find(
            item => (item.url || item) === url
          )
          return existing ? existing : { url }
        })
      } else {
        res = list.join(',')
      }
      emit('update:fileList', res)
      emit('setImgUrl', props.type, res)
    }

    const beforeUpload = file => {
      return new Promise((resolve, reject) => {
        const isSize = file.file.size / 1024 > props.imageType.size
        if (isSize) {
          message.warning(`上传的图片不能大于${props.imageType.size}kb`)
          return reject(false)
        }
        let w = 0,
          h = 0
        const reader = new FileReader()
        reader.readAsDataURL(file.file)
        reader.onload = () => {
          const image = new Image()
          image.src = reader.result
          image.onload = () => {
            w = image.width
            h = image.height
            const rules =
              w / h === props.imageType.width / props.imageType.height
            if (rules) {
              uploadImg(file.file)
              // 图片尺寸上限为550
              return resolve(true)
            }
            message.warning('图片尺寸不正确！')
            return reject(false)
          }
        }
      })
    }
    const uploadImg = async file => {
      loading.value = true
      const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
      const { success, retInfo, data } = await formRequest(api, {
        file: file
      })
      loading.value = false
      if (success) {
        const currentList = [...imageUrlList.value]
        currentList.push(data.url)
        emitChange(currentList)
      } else {
        message.error(retInfo || '上传失败')
      }
    }
    const handleCancel = () => {
      previewVisible.value = false
    }
    const openView = url => {
      previewUrl.value = url
      previewVisible.value = true
    }
    const delImg = index => {
      const currentList = [...imageUrlList.value]
      currentList.splice(index, 1)
      if (props.limit === 1 && currentList.length === 0) {
        emit('delActivityImg', props.type)
      }
      emitChange(currentList)
    }

    return {
      imageUrlList,
      loading,
      tip,
      previewVisible,
      previewUrl,
      beforeUpload,
      handleCancel,
      openView,
      delImg
    }
  }
}
</script>

<style lang="scss" scoped>
.uploadImg-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  .tip {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    width: 104px;

    text-align: center;
  }
  .img-wrapper {
    position: relative;
    .img {
      width: 100%;
    }
    .hover-img {
      display: none;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
    }
    &:hover .hover-img {
      display: flex;
      background-color: rgba(0, 0, 0, 0.45);
      align-items: center;
      justify-content: center;
    }
  }
}
.ant-upload-picture-card-wrapper {
  width: 104px;
  margin: 0;
  margin: 10px;
}
</style>
